module.exports = __webpack_public_path__ + "centric-mockup.CelWYSb-.png";